// src/redux/reducers/menuManageReducer.js

import { combineReducers } from "redux";

import tableSlice from "../slice/table-slice/table-slice";
import liveTableSlice from "../slice/table-slice/live-table-slice";
import bookingTableSlice from "../slice/table-slice/booking-table-slice";

const tableReducer = combineReducers({
  table: tableSlice,
  liveTable: liveTableSlice,
  bookingTable: bookingTableSlice,
});

export default tableReducer;
